import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomModal from "components/Modals/CustomModal";
import { getPathPrefix } from "utils/coreUtils";

const ItemActions = ({
  actionId,
  classes = "",
  editTooltip,
  editPath,
  canEdit = true,
  viewTooltip,
  viewPath,
  deleteTooltip,
  deleteMessage,
  deleteId,
  deleteHandler,
  validateDelete,
  canDelete = true,
  additonalActions = [],
  size = "lg",
}) => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const actions = useMemo(() => {
    const editActionButtonEl = (
      <span className="action-icon">
        <button
          onClick={() => {
            navigate(getPathPrefix(editPath));
          }}
          disabled={!canEdit}
        >
          <i className="fa-regular fa-edit"></i>
        </button>
      </span>
    );
    const editAction = editTooltip ? (
      <OverlayTrigger
        placement="auto"
        overlay={(props) => (
          <Tooltip id="edit-tooltip" {...props}>
            {editTooltip}
          </Tooltip>
        )}
      >
        {editActionButtonEl}
      </OverlayTrigger>
    ) : (
      editActionButtonEl
    );

    const viewActionButtonEl = (
      <span className="action-icon">
        <button
          onClick={() => {
            navigate(getPathPrefix(viewPath));
          }}
        >
          <i className="fa-regular fa-eye"></i>
        </button>
      </span>
    );

    const viewAction = viewTooltip ? (
      <OverlayTrigger
        placement="auto"
        overlay={(props) => (
          <Tooltip id="view-tooltip" {...props}>
            {viewTooltip}
          </Tooltip>
        )}
      >
        {viewActionButtonEl}
      </OverlayTrigger>
    ) : (
      viewActionButtonEl
    );
    const deleteActionButtonEl = (
      <span className="action-icon">
        <button
          onClick={() => {
            if (validateDelete) {
              const shouldShowDelete = validateDelete();
              console.log(shouldShowDelete);
              shouldShowDelete && setShowDelete(true);
              return;
            }
            setShowDelete(true);
          }}
          disabled={!canDelete}
        >
          <i className="fa-regular fa-trash-can"></i>
        </button>
      </span>
    );
    const deleteAction = deleteTooltip ? (
      <OverlayTrigger
        placement="auto"
        overlay={(props) => (
          <Tooltip id="delete-tooltip" {...props}>
            {deleteTooltip}
          </Tooltip>
        )}
      >
        {deleteActionButtonEl}
      </OverlayTrigger>
    ) : (
      deleteActionButtonEl
    );
    const actionList = [editAction, viewAction, deleteAction];
    if (additonalActions.length > 0) {
      additonalActions.forEach((action) => {
        actionList.splice(action.sequence, 0, action.action);
      });
    }
    return actionList;
  }, [additonalActions, canDelete, canEdit, editPath, navigate, t, viewPath]);
  return (
    <>
      <div className={`row gap-2 justify-content-center ${classes} ${size}`}>
        {actions.map((action, index) => (
          <React.Fragment key={`${actionId}-${index}`}>{action}</React.Fragment>
        ))}
      </div>
      <CustomModal
        show={showDelete}
        centered
        noHeader
        body={
          <h5
            className="modal-title text-center w-100"
            style={{ color: "#004e5c" }}
          >
            {deleteMessage}
          </h5>
        }
        okTitle={t("CommonKeys.yes")}
        cancelTitle={t("CommonKeys.no")}
        centerFooter
        onOk={() => {
          deleteHandler(deleteId);
          setShowDelete(false);
        }}
        onCancel={() => {
          setShowDelete(false);
        }}
      />
    </>
  );
};

export default ItemActions;
